import React from 'react';
import Drawer, { FooterSpacer } from '../Drawer';
import Button from '../Button';
import Field from '../Field';
import ParamField from './ParamField';
import { REPORT_TYPES, REPORTS_WORDING as W } from '../../domain/reports';
import s from './reports.module.css';

// Pick a report type, then fill in whatever that type asks for. `waiting` is
// the core's reason Create is disabled while a list the report reads has not
// been read (#646), or null.

export default function CreateReportDrawer({
  open, onClose, typeId, type, params, error, saving, waiting = null,
  onPickType, onParamChange, onRun,
}) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={W.createTitle}
      footer={(
        <>
          <Button variant="secondary" onClick={onClose}>{W.cancel}</Button>
          <FooterSpacer />
          <Button onClick={onRun} loading={saving} disabled={!typeId || Boolean(waiting)}>{W.create}</Button>
        </>
      )}
    >
      {error ? <div className={s.error}>{error}</div> : null}

      <div className={s.formTop}>
        <Field label={W.reportType}>
          <select className={s.input} value={typeId} onChange={(e) => onPickType(e.target.value)}>
            <option value="">{W.selectType}</option>
            {REPORT_TYPES.map((r) => <option key={r.id} value={r.id}>{r.label}</option>)}
          </select>
        </Field>
        {type ? <div className={s.typeDescription}>{type.description}</div> : null}
        {waiting ? <div className={s.waiting} role="status">{waiting}</div> : null}
      </div>

      {type ? (
        <div className={s.params}>
          {type.params.map((p) => (
            <ParamField
              key={p.id}
              param={p}
              value={params[p.id]}
              onChange={(v) => onParamChange(p.id, v)}
            />
          ))}
        </div>
      ) : null}
    </Drawer>
  );
}
